import PropTypes from 'prop-types'
import React from 'react'
import { connect } from 'react-redux'
import { FormattedMessage } from 'react-intl'
import { Button } from 'components/util'
import styles from './_login.css'
import * as authActions from 'services/auth/actions'

const mapStateToProps = () => ({

})

const mapDispatchToActions = {
  ...authActions,
}

class FacebookLoginButton extends React.Component {
  componentDidMount () {
    this.props.getFacebookLoginStatus().then(res => {
      if (res.value.status === 'connected') {
        this.props.loginWithFacebook(true).then(this.props.onLoginSuccess)
      }
    })
  }

  handleClickLoginWithFacebook = () => {
    this.props.setLoginSubmitting(true)

    this.props.loginWithFacebook(this.props.reload)
      .then(this.props.onLoginSuccess)
      .catch((err) => {
        if (err && err.response && err.response.data && err.response.data.error) {
          // unable to login via facebook, maybe they want to create
          // an account w/ facebook instead?
          if (err.response.data.error === 'access_denied') {
            return this.props.initSignupWithFacebook()
              .then(() => { this.props.onClickSignup() })
          } else {
            this.props.setLoginError(err.response.data.error)
          }
        } else {
          this.props.setLoginError('unknown')
        }
      })

  }

  render () {
    return (
      <div className={styles.facebook}>
        <Button
          disabled={this.props.disabled}
          type='facebook'
          icon='facebook_circle'
          className={styles.button}
          onClick={this.handleClickLoginWithFacebook}
        >
          <FormattedMessage
            id='auth.login.signup_with_facebook'
            defaultMessage='Log in with Facebook'
          />
        </Button>
      </div>
    )
  }
}

FacebookLoginButton.propTypes = {
  disabled: PropTypes.bool,
  getFacebookLoginStatus: PropTypes.func.isRequired,
  initSignupWithFacebook: PropTypes.func.isRequired,
  onClickSignup: PropTypes.func,
  loginWithFacebook: PropTypes.func.isRequired,
  onLoginSuccess: PropTypes.func.isRequired,
  reload: PropTypes.bool,
  setLoginError: PropTypes.func,
  setLoginSubmitting: PropTypes.func,
}

export default connect(mapStateToProps, mapDispatchToActions)(FacebookLoginButton)
